import { ShopifyStoreProduct, VenueGetShopifyStoreProductFilter } from '../../graphql/API';
import { venueGetShopifyStoreProduct } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueGetShopifyStoreProductApi = async (
  filter: VenueGetShopifyStoreProductFilter,
): Promise<ShopifyStoreProduct> => {
  const result = await executeGql(venueGetShopifyStoreProduct, { filter });
  return processGqlResult('venueGetShopifyStoreProduct', result);
};
